
const NewsMode = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_3616_1883" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3616_1883)">
                <path d="M4.48496 20.5C3.97639 20.5 3.54593 20.325 3.19357 19.975C2.84122 19.625 2.66504 19.1974 2.66504 18.6923V5.30775C2.66504 4.80258 2.84122 4.375 3.19357 4.025C3.54593 3.675 3.97639 3.5 4.48496 3.5H19.9731C20.4816 3.5 20.9121 3.675 21.2645 4.025C21.6168 4.375 21.793 4.80258 21.793 5.30775V18.6923C21.793 19.1974 21.6168 19.625 21.2645 19.975C20.9121 20.325 20.4816 20.5 19.9731 20.5H4.48496ZM6.57595 16.6152H17.8821V15.1155H6.57595V16.6152ZM6.57595 12.75H10.2931V7.38475H6.57595V12.75ZM12.5001 12.75H17.8821V11.25H12.5001V12.75ZM12.5001 8.8845H17.8821V7.38475H12.5001V8.8845Z" fill='var(--primary-text)' />
            </g>
        </svg>

    )
};
export default NewsMode;
